import {extendTheme} from '@tempo/core';
import datepicker from './globals/datepicker';
import {d4cSizes} from '@deezer/next/shared/theme/d4cSizes';

const config = {
	initialColorMode: 'light',
	useSystemColorMode: false,
};

const theme = {
	config,
	styles: {
		global: () => ({
			html: {
				height: '100vh',
			},
			a: {
				color: 'text.neutral.primary.default',
				textDecoration: 'none',
				outline: '0 none',
			},
			body: {
				background: 'background.neutral.primary.default',
			},
			...datepicker,
		}),
	},
	sizes: {
		d4c: d4cSizes,
		container: {
			xs: '432px',
			'2xl': `1800px`,
		},
	},
	space: {
		d4c: d4cSizes,
	},
};

const extendedTheme = extendTheme(theme);

export default extendedTheme;
